import React from 'react';

// Components
import PublicProfileLink from './PublicProfileLink';
import SuspendProfileToggle from './SuspendProfileToggle';
import GiveFreeSubscription from './GiveFreeSubscription';
import DeleteProfile from './DeleteProfile';

const ProfileActions = ({ suspended, free_subscription, username, toggleSuspension, makeFree, deleteProfile }) => (
  <div className="admin-profile-card-actions">
    <PublicProfileLink username={username} />
    <span className="separator"> | </span>
    <SuspendProfileToggle suspended={suspended} toggleSuspension={toggleSuspension} />
    <GiveFreeSubscription  free_subscription={free_subscription} makeFree={makeFree} />
    <span className="separator"> | </span>
    <DeleteProfile deleteProfile={deleteProfile} />
  </div>
)

export default ProfileActions



// WEBPACK FOOTER //
// ./src/components/Admin/Profile/ProfileActions.js